import { Box } from '@mui/material';
import { type ReactNode } from 'react';
import { useBottomBarStyles } from './bottomBar.styles';

interface BottomBarProps {
  children?: ReactNode;
}

const BottomBar = ({ children }: BottomBarProps) => {
  const { classes } = useBottomBarStyles();

  return <Box className={classes.root}>{children}</Box>;
};

export default BottomBar;
